import { ComponentNameEnum } from '@/types';

export interface GameStockEditorOptions {
  gameType: 'wheel' | 'slotMachine' | 'scratchCard';
}

const getGameStockEditorFieldConfig = (options: GameStockEditorOptions) => ({
  componentName: ComponentNameEnum.GAME_STOCK_EDITOR,
  options: {
    gameType: options.gameType,
  },
});

export default getGameStockEditorFieldConfig;
